<template>
  <v-container fluid>
    <a-page-header title="Dossiers" icon="flaticon-portfolio"/>       

    <v-divider/>

     <v-row>
        <v-col sm="12">
    
          <v-tabs v-model="tab">
              <v-tab href="#tab-1" @click="onClickTab('stream')">Flux</v-tab>
              <v-tab href="#tab-2" @click="onClickTab('activated')">En cours</v-tab>
              <v-tab href="#tab-3" @click="onClickTab('archived')">Terminés</v-tab>        
          </v-tabs>
          
            <v-tabs-items v-model="tab">
              
            <v-tab-item value="tab-1">
              <v-card flat>
                <v-card-text>
                  <div>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Rechercher"
                      single-line
                      hide-details
                      clearable
                    ></v-text-field>
                  </div>                
                  
                  <v-list rounded>                    
                    <a-dossier-item v-for="(item, index) in filteredDossiers.stream" 
                      :item="item" :key="item.id" 
                      :last="index === filteredDossiers.stream.length - 1" 
                      @select="onClickDossierItem"
                    />
                  </v-list>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item value="tab-2">
              <v-card flat>
                <v-card-text>
                    <div>
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Rechercher"
                        single-line
                        hide-details
                        clearable
                      ></v-text-field>
                  </div>      
                  
                  <v-row align="center">
                    <v-col sm="2">
                      <v-switch
                        v-model="showMileage"
                        flat
                        dense
                        label="Relevé kilométrique"
                      ></v-switch>
                    </v-col>

                    <v-col sm="2">
                      <v-switch
                        v-model="showAudit"
                        flat
                        dense
                        label="Audit Vehicule"
                      ></v-switch>
                    </v-col>

                    <v-spacer></v-spacer>

                    <v-col cols="auto" v-if="showActionButton && multiSelectMode">
                      <v-btn
                        color="red"
                        dark
                        small
                        :disabled="selectedIds.length === 0"
                        @click="confirmDeleteDialog = true"
                      >
                        <v-icon left small>mdi-delete</v-icon>
                        Supprimer la sélection ({{ selectedIds.length }})
                      </v-btn>
                    </v-col>

                    <v-col cols="auto" v-if="showActionButton">
                      <v-switch
                        v-model="multiSelectMode"
                        flat
                        dense
                        label="Sélection multiple"
                      ></v-switch>
                    </v-col>
                  </v-row>


                  <div class="text-center mt-10" v-if="isLoading">
                    <v-progress-circular
                      :size="50"
                      :width="3"
                      indeterminate
                    ></v-progress-circular>
                  </div>
                  <template v-else>
                    <div v-if="showActionButton && multiSelectMode" class="d-flex align-center pl-2">
                      <v-checkbox
                        :input-value="isAllSelected(filteredDossiers.activated)"
                        :indeterminate="isIndeterminate(filteredDossiers.activated)"
                        label="Tout sélectionner"
                        hide-details
                        dense
                        class="mt-0 pt-0"
                        @change="toggleSelectAll(filteredDossiers.activated)"
                      ></v-checkbox>
                    </div>
                    <v-list rounded>
                      <a-dossier-item v-for="(item, index) in filteredDossiers.activated"
                        :item="item"
                        :key="item.id"
                        :last="index === filteredDossiers.activated.length - 1"
                        :btn-recall="showActionButton && !multiSelectMode"
                        :btn-delete="showActionButton && !multiSelectMode"
                        :selectable="showActionButton && multiSelectMode"
                        :selected="selectedIds.includes(item.id)"
                        @delete="deleteItem"
                        @recall="updateItem($event, item)"
                        @toggle-select="toggleSelectItem"
                        @select="onClickDossierItem"/>
                    </v-list>
                  </template>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item value="tab-3">
              <v-card flat>
                <v-card-text>
                    <div>
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Rechercher"
                        single-line
                        hide-details
                        clearable
                      ></v-text-field>
                  </div>

                  <v-row align="center">
                    <v-col sm="2">
                      <v-switch
                        v-model="showMileage"
                        flat
                        dense
                        label="Relevés kilométriques"
                      ></v-switch>
                    </v-col>

                    <v-col sm="2">
                      <v-switch
                        v-model="showAudit"
                        flat
                        dense
                        label="Audits Vehicule"
                      ></v-switch>
                    </v-col>

                    <v-spacer></v-spacer>

                    <v-col cols="auto" v-if="showActionButton && multiSelectMode">
                      <v-btn
                        color="red"
                        dark
                        small
                        :disabled="selectedIds.length === 0"
                        @click="confirmDeleteDialog = true"
                      >
                        <v-icon left small>mdi-delete</v-icon>
                        Supprimer la sélection ({{ selectedIds.length }})
                      </v-btn>
                    </v-col>

                    <v-col cols="auto" v-if="showActionButton">
                      <v-switch
                        v-model="multiSelectMode"
                        flat
                        dense
                        label="Sélection multiple"
                      ></v-switch>
                    </v-col>
                  </v-row>

                  <div class="text-center mt-10" v-if="isLoading">
                    <v-progress-circular
                      :size="50"
                      :width="3"
                      indeterminate
                    ></v-progress-circular>
                  </div>
                  <template v-else>
                    <div v-if="showActionButton && multiSelectMode" class="d-flex align-center pl-2">
                      <v-checkbox
                        :input-value="isAllSelected(filteredDossiers.archived)"
                        :indeterminate="isIndeterminate(filteredDossiers.archived)"
                        label="Tout sélectionner"
                        hide-details
                        dense
                        class="mt-0 pt-0"
                        @change="toggleSelectAll(filteredDossiers.archived)"
                      ></v-checkbox>
                    </div>
                    <v-list rounded>
                      <a-dossier-item v-for="(item, index) in filteredDossiers.archived"
                        :item="item"
                        :key="item.id"
                        :last="index === filteredDossiers.archived.length - 1"
                        :btn-delete="showActionButton && !multiSelectMode"
                        :selectable="showActionButton && multiSelectMode"
                        :selected="selectedIds.includes(item.id)"
                        @delete="deleteItem"
                        @toggle-select="toggleSelectItem"
                        @select="onClickDossierItem"
                      />
                    </v-list>
                  </template>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>

        </v-col>
     </v-row>

     <v-dialog v-model="confirmDeleteDialog" max-width="420">
        <v-card>
          <v-card-title>Confirmer la suppression</v-card-title>
          <v-card-text>
            Voulez-vous vraiment supprimer {{ selectedIds.length }} dossier(s) sélectionné(s) ? Cette action est irréversible.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="confirmDeleteDialog = false">Annuler</v-btn>
            <v-btn color="red" dark :loading="isDeletingSelection" @click="deleteSelection">Supprimer</v-btn>
          </v-card-actions>
        </v-card>
     </v-dialog>

  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import dossierService from '@/services/dossierService'
import APageHeader from "@/components/APageHeader"
import ADossierItem from "@/components/ADossierItem"

export default {
  name: 'Dossiers',
  components: { APageHeader, ADossierItem },
  data: () => ({
    intervalId: undefined,
    interval: 10000,
    isLoading: false,
    showAudit: true,
    showMileage: true,
    multiSelectMode: false,
    selectedIds: [],
    isDeletingSelection: false,
    confirmDeleteDialog: false,
    dossiers: {
      stream: [],
      activated: [],
      archived: []    
    },
    filteredDossiers: {
      stream: [],
      activated: [],
      archived: []    
    },
    status: 'stream',
    search: ''
  }),
  methods: {
    onClickDossierItem: function(id) {
        this.$router.push({ 
          name: 'Dossier', 
          params: { 
            id: id
          }
        })
      },

    onClickTab: function(status) {
      if (status !== undefined) this.status = status     
      this.search = ''
      this.showAudit = true;
      this.showMileage = true;
      this.get()
    },
    statusFromTab: function(tab) {
      if (tab === 'tab-2') return 'activated'
      if (tab === 'tab-3') return 'archived'
      return 'stream'
    },

    // Méthodes d'accès aux données
    // ----------------------------
    // Liste des demandes de l'utilisateur
    get: function() {
        this.isLoading = true
        dossierService.getAll(this.status)
            .then(data => {
                this.dossiers[this.status] = []
                this.filteredDossiers[this.status] = []
                this.dossiers[this.status] = data
                this.filterRequests()
                this.isLoading = false
            })
            .catch(error => {
                this.isLoading = false
                this.$root.$emit("serverError", error);
            });
    },

    // Méthodes fonctionnelles
    // -----------------------
    updateItem: function(newItem, item) {                  
      Object.assign(item, newItem)
    },
    deleteItem: function(id) {
      this.dossiers[this.status] = this.dossiers[this.status].filter(el => el.id !== id)
      this.filteredDossiers[this.status] = this.filteredDossiers[this.status].filter(el => el.id !== id)
    },
    toggleSelectItem: function(id) {
      if (this.selectedIds.includes(id)) this.selectedIds = this.selectedIds.filter(el => el !== id)
      else this.selectedIds = [...this.selectedIds, id]
    },
    isAllSelected: function(list) {
      return list.length > 0 && list.every(el => this.selectedIds.includes(el.id))
    },
    isIndeterminate: function(list) {
      return list.some(el => this.selectedIds.includes(el.id)) && !this.isAllSelected(list)
    },
    toggleSelectAll: function(list) {
      const ids = list.map(el => el.id)
      if (this.isAllSelected(list)) this.selectedIds = this.selectedIds.filter(id => !ids.includes(id))
      else this.selectedIds = [...new Set([...this.selectedIds, ...ids])]
    },
    deleteSelection: function() {
      if (this.selectedIds.length === 0) return
      this.isDeletingSelection = true
      dossierService.remove(this.selectedIds.join(','))
          .then(() => {
            this.selectedIds.forEach(id => this.deleteItem(id))
            this.selectedIds = []
            this.isDeletingSelection = false
            this.confirmDeleteDialog = false
          })
          .catch(error => {
            this.isDeletingSelection = false
            this.confirmDeleteDialog = false
            this.$root.$emit("serverError", error);
          });
    },
    // Filtre les demandes du status en cour en fonction du contenu de la zone de recherche
    filterRequests: function() {    
        this.filteredDossiers[this.status] = this.dossiers[this.status].filter(el =>  {  
            let filterResult = true
            if (this.search && this.search != '') {
              filterResult = `${el.recipient.lastname} ${el.recipient.firstname} ${el.recipient.work.name} ${el.recipient.work.agency ? el.recipient.work.agency.name : ''} ${el.vehicle_audit ? el.vehicle_audit.vehicle.registration : ''}  ${el.vehicle_mileage ? el.vehicle_mileage.vehicle.registration : ''}`.toLowerCase().indexOf(this.search.toLowerCase()) !== -1  
            }
            if (filterResult) {              
              if (this.showAudit && el.vehicle_audit !== undefined) filterResult = true
              else if (this.showMileage && el.vehicle_mileage !== undefined) filterResult = true              
              else filterResult = false
            }
           
            return filterResult
        })      
    }

  },
  watch: {
    showAudit: function() {      
      this.filterRequests()
    },    
    showMileage: function() {
      this.filterRequests()
    },
    search: function() {      
       this.filterRequests()
    },
    tab: function(value) {
      const status = this.statusFromTab(value)
      if (status !== this.status) this.onClickTab(status)
    },
    multiSelectMode: function() {
      this.selectedIds = []
      this.confirmDeleteDialog = false
    },
    status: function() {
      this.multiSelectMode = false
      this.selectedIds = []
      this.confirmDeleteDialog = false
    }
  },
  computed: {
    ...mapGetters([
      'userEnvironment',
      'profile',
      'dossiersTab'
    ]),
    tab: {
      get() {
        return this.dossiersTab
      },
      set(value) {
        this.$store.commit('setDossiersTab', value)
      }
    },
    showActionButton: function() {  return this.profile.is_su || this.profile.role == this.$constants.users.USER_ROLE_MANAGER || this.profile.role == this.$constants.users.USER_ROLE_ADMIN }
  },
  mounted() {
    this.onClickTab(this.statusFromTab(this.tab))
    this.intervalId = setInterval(() => { 
        if (this.status == 'stream') this.get()
      }, 
      this.interval)
  },
  destroyed() {
    clearInterval(this.intervalId)
  }
}
</script>

<style scoped>

</style>
